import {combineReducers} from 'redux';

import add from './org-comment-add/reducer';
import del from './org-comment-delete/reducer';
import edit from './org-comment-edit/reducer';
import index from './org-comments-index/reducer';

export default combineReducers({index, add, edit, del});
